import BaseViewController from "./base-view-controller";

class MessageCenterReplyViewController extends BaseViewController {
  handleButtonClick(name, text, action) {
    if (name === "acceptButton" || name === "sendButton") {
      super.handleButtonClick(name, text, action, 2);
    } else {
      super.handleButtonClick(name, text, action);
    }
  }
}

export default MessageCenterReplyViewController;
